import SellInvoiceForm from 'components/Form/Tenant/SellInvoice/SellInvoiceForm';
import React from 'react';
import { useParams } from 'react-router-dom';
import { Container } from 'reactstrap';

const MedicineSellEntryPage: React.FC = () => {
  const { invoiceId } = useParams<{ invoiceId: string }>();
  return (
    <div className="page-content">
      <Container fluid>
        <SellInvoiceForm invoiceId={invoiceId} />
      </Container>
    </div>
  );
};

export default MedicineSellEntryPage;
